<!--
@component
AllMatches

Variant of the matches widget that renders the next N live/upcoming
matches across the whole tournament. Used when the embed is loaded
without a `?country=…` query parameter.

The window size (`MAX_MATCHES`) is responsive — wider on desktop,
tighter on mobile — and is shared with the team-page variant via
`./railWindow`.
-->

<script lang="ts">
  import MatchRail from './MatchRail.svelte';
  import { appState } from '$lib/stores/index.svelte';
  import getContestedMatches from '$utils/getContestedMatches/index.js';
  import { getLiveAndUpcomingMatches } from '$utils/getNextMatches';
  import { getMaxMatches } from './railWindow.svelte';
  import type { ContestedMatch } from '$lib/@types/opta';

  /** Responsive cap on how many cells the rail surfaces. */
  const MAX_MATCHES = $derived(getMaxMatches());

  const allContestedMatches = $derived<ContestedMatch[]>(
    getContestedMatches(appState.optaData)
  );

  const matches = $derived<ContestedMatch[]>(
    getLiveAndUpcomingMatches(allContestedMatches, MAX_MATCHES)
  );
</script>

<MatchRail {matches} />
